<div class="wrapper">
  <form [formGroup]="form">
    <div class="two-items">
      <div class="form-component inspection-forms-field">
        <mat-form-field>
          <mat-select formControlName="Layer" matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}">
            <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }})
            </mat-option>
          </mat-select>
          <mat-placeholder>{{
            layers.length ? ("configurationTab.layer" | translate) : ("configurationTab.noLayer" | translate)
            }}</mat-placeholder>
        </mat-form-field>
        <mat-icon class="update-icon" mat-icon-button (click)="updateLayers()">sync</mat-icon>
      </div>

      <div class="form-component toggle-only-second"
           *ngIf="isDisplayExcludeFromProcessing()">
        <mat-slide-toggle
          formControlName="IsExcludedFromProcessing"
          matTooltip="{{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}"
          color="primary"
        >
          {{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}
        </mat-slide-toggle>
      </div>
    </div>

    <div class="form-component main-color">
      <mee-color-picker [position]="colorPickerPosition" formControlName="MainColor"></mee-color-picker>
    </div>
  </form>
</div>
